export const ATM_WITHDRAWAL_EXAMPLES = [
    {
        name: 'BoA DC',
        json: {
            card_acceptor: {
                address: '1 Ridge Sq NW',
                city: 'Washington',
                country: 'USA',
                mcc: '6011',
                name: 'BANK OF AMERICA*CITY RIDG',
                state: 'DC',
                zip: '20016',
            },
            account_type: 'credit',
            mid: '123141',
        },
    },
];

export const CARD_TRANSACTION_EXAMPLES = [
    {
        name: 'GIANT 2379 WASHINGTON DC',
        json: {
            card_acceptor: {
                partial_approval_capable: false,
                address: '3336 Wisconsin Ave NW',
                city: 'WASHINGTON',
                country: 'USA',
                mcc: '5411',
                name: 'GIANT 2379',
                state: 'DC',
                zip: '20016',
            },
            card_options: {
                card_present: true,
            },
            is_pre_auth: false,
            transaction_options: {
                is_async: false,
                send_expiration_date: false,
                send_track_data: false,
            },
            mid: '12345678',
        },
    },
    {
        name: 'STARBUCKS STORE 21159 WASHINGTON DC',
        json: {
            card_acceptor: {
                partial_approval_capable: false,
                address: '3416 Wisconsin Ave NW',
                city: 'WASHINGTON',
                country: 'USA',
                mcc: '5812',
                name: 'STARBUCKS STORE 21159',
                state: 'DC',
                zip: '20016',
            },
            card_options: {
                card_present: true,
            },
            is_pre_auth: false,
            transaction_options: {
                is_async: false,
                send_expiration_date: false,
                send_track_data: false,
            },
            mid: '123456789',
        },
    },
    {
        name: "SQ *ZEKE'S COFFEE OF D Washington DC",
        json: {
            card_acceptor: {
                partial_approval_capable: false,
                address: '731 15th Street NW',
                city: 'WASHINGTON',
                country: 'USA',
                mcc: '5812',
                name: "SQ *ZEKE'S COFFEE OF D",
                state: 'DC',
                zip: '20005',
            },
            card_options: {
                card_present: true,
            },
            is_pre_auth: false,
            transaction_options: {
                is_async: false,
                send_expiration_date: false,
                send_track_data: false,
            },
            mid: '1234567890',
        },
    },
    {
        name: 'TST* TATTE BAKERY & CA WASHINGTON DC',
        json: {
            card_acceptor: {
                partial_approval_capable: false,
                address: '13 Ridge Square NW',
                city: 'WASHINGTON',
                country: 'USA',
                mcc: '5812',
                name: 'TST* TATTE BAKERY & CA',
                state: 'DC',
                zip: '20016',
            },
            card_options: {
                card_present: true,
            },
            is_pre_auth: false,
            transaction_options: {
                is_async: false,
                send_expiration_date: false,
                send_track_data: false,
            },
            mid: '1234567890',
        },
    },
    {
        name: 'COLPARK LOC 141 WASHINGTON DC',
        json: {
            card_acceptor: {
                partial_approval_capable: false,
                address: '3201 New Mexico Ave NW',
                city: 'WASHINGTON',
                country: 'USA',
                mcc: '5812',
                name: 'COLPARK LOC 141',
                state: 'DC',
                zip: '20016',
            },
            card_options: {
                card_present: true,
            },
            is_pre_auth: false,
            transaction_options: {
                is_async: false,
                send_expiration_date: false,
                send_track_data: false,
            },
            mid: '1234567890',
        },
    },
    {
        name: 'PY *TEAISM PENN QUARTE WASHINGTON DC',
        json: {
            card_acceptor: {
                partial_approval_capable: false,
                address: '400 8th St NW',
                city: 'Washington',
                country: 'USA',
                mcc: '5812',
                name: 'PY *TEAISM PENN QUARTE',
                state: 'DC',
                zip: '20004',
            },
            card_options: {
                card_present: true,
            },
            is_pre_auth: false,
            transaction_options: {
                is_async: false,
                send_expiration_date: false,
                send_track_data: false,
            },
            mid: '1234567890',
        },
    },
    {
        name: 'Patreon* Membership Internet CA',
        json: {
            card_acceptor: {
                partial_approval_capable: false,
                mcc: '5947',
                city: 'Internet',
                state: 'CA',
                name: 'Patreon* Membership',
            },
            card_options: {
                card_present: false,
            },
            is_pre_auth: false,
            transaction_options: {
                is_async: false,
                send_expiration_date: false,
                send_track_data: false,
            },
            mid: '1234567890',
        },
    },
    {
        name: 'ASTOUND POWERED BY RCN 800-746-4726 PA',
        json: {
            card_acceptor: {
                partial_approval_capable: false,
                mcc: '4899',
                city: '800-746-4726',
                state: 'PA',
                name: 'ASTOUND POWERED BY RCN',
            },
            card_options: {
                card_present: false,
            },
            is_pre_auth: false,
            transaction_options: {
                is_async: false,
                send_expiration_date: false,
                send_track_data: false,
            },
            mid: '1234567890',
        },
    },
];
